import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import logo from "../icon/good2swim-logo.png";
import HomeSVG from "../icon/house.svg";
import eject from "../icon/eject.svg";
import studentIcon from "../icon/people.svg";
import saleIcon from "../icon/sale.svg";
import adminIcon from "../icon/admin.svg";
import classIcon from "../icon/swimClass.svg";
import starIcon from "../icon/star.svg";
import pencilIcon from "../icon/pencil.svg";
import SearchIcon from "../icon/search.svg";
import lotIcon from "../icon/sliders.svg";
import fingerTap from "../icon/tap.svg"

const FunBarClassForCoach = (props) => {
  let classDBID = props.classDBID;
  let classDate=props.classDate
  let toGoTodayClass="/GetDailyTable/"+classDate;
  let newOrder = "/newOrder/" + classDBID;
  let makeClassRecord = "/makeClassRecord/" + classDBID;
  let makeLotClassReocrd = "/makeLotClassReocrd/" + classDBID;
  const version = "V 3.0.1 ";
  var imgStyle = {
    width: "30px",
    height: "30px",
  };

  var fontStyle = {
    fontSize: "0.5em",
  };
  //menu Bar 元作
  return (
    <nav className="navbar navbar-light bg-warning rounded-top py-1 ">
            <div className="mr-auto">
            <div
          className="navbar-brand "
          
          onClick={()=>{
            window.location.href=`/SingleClassView/${classDBID}`
          }}
          style={{ textAlign: "center" }}
        >
          <img src={pencilIcon} style={imgStyle} alt="Home" />
          <span className="text-dark" style={fontStyle}>
            {" "}
            單堂課程資訊
          </span>
        </div>
      </div>

      
      <div className="mr-auto">
        <div
          className="navbar-brand "
          
          onClick={()=>{
            window.location.href=`/classEdit/${classDBID}`
          }}
          style={{ textAlign: "center" }}
        >
          <img src={pencilIcon} style={imgStyle} alt="Home" />
          <span className="text-dark" style={fontStyle}>
            {" "}
            編輯課程
          </span>
        </div>
      </div>
     
      
    </nav>
  );
};

export default FunBarClassForCoach;
